export type TabOption<T extends string> = {
    label: string;
    value: T;
};

export const enum TabVariant {
    Colored = "colored",
    Neutral = "neutral",
}
